import { colors } from "../pages/bookings/ChooseBooking";

interface CountSelectProps {
  possibleCounts: number[];
  desiredCount: number;
  onCountChange: (count: number) => void;
}

const CountSelect = ({ possibleCounts, desiredCount, onCountChange }: CountSelectProps) => {
  return (
    <div className="grid grid-cols-4 sm:grid-cols-8 gap-2">
      {possibleCounts.map((count) => {
        // Különböző színek a csempékhez
        const colorIndex = (count - 1) % colors.length;
        const color = colors[colorIndex];

        return (
          <button
            key={count}
            onClick={(e) => {
              e.preventDefault(); // Megelőzzük az alapértelmezett form submit viselkedést
              onCountChange(count);
            }}
            type="button" // Explicit megadjuk, hogy ez egy sima gomb, nem submit
            className={`p-2 rounded-md shadow-sm transition-all duration-200 transform ${desiredCount === count
              ? `${color.selected} ${color.text} scale-105 outline outline-2 outline-offset-2 ${color.outline}`
              : `${color.bg} ${color.text} ${color.hover}`
              }`}
          >
            <div className="flex items-center justify-center">
              <span className="font-bold text-lg">{count}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default CountSelect;